import { render, staticRenderFns } from "./ProjectApprovalSetting.vue?vue&type=template&id=54305264&scoped=true&"
import script from "./ProjectApprovalSetting.vue?vue&type=script&lang=js&"
export * from "./ProjectApprovalSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProjectApprovalSetting.vue?vue&type=style&index=0&id=54305264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54305264",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
